import React from 'react'
import {useHistory} from 'react-router-dom'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import {makeStyles, useTheme} from 'external/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import useMediaQuery from '@mui/material/useMediaQuery'
import Body from './Body'

const useStyles = makeStyles(previewStyles)
const useTitleStyles = makeStyles(titleStyles)
const useDialogStyles = makeStyles(dialogStyles)

export default function PreviewBlankPdf ({context}) {

  const theme = useTheme()
  const history = useHistory()
  const contentRef = React.createRef()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const {translate, assignmentId, quizStudentAssessments: assessments, link, linkQuery} = context

  const assignment = context.quizAssignments.find(a => a.id == assignmentId) || {}
  const title = assignment.id != undefined
    ? `${assignment.title} - ${assignment.groupName}`
    : translate('assessment')

  const classes = useStyles()
  const titleClasses = useTitleStyles()
  const dialogClasses = useDialogStyles()

  const isOpen = assignmentId != undefined && assessments.length > 0 && context.quizStudentAssessmentAssignmentId == assignmentId

  function close () {
    let href = link({}, '/:languageId/:role/:page/:tab')
    if (context.quizReviewFrom) {
      href = linkQuery(context.quizReviewFrom, context.quizReviewFromQuery)
      context.updateState({quizReviewFrom: {$set: undefined}, quizReviewFromQuery: {$set: {}}})
    }
    history.push(href)
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={e => close()}
      classes={dialogClasses}
      aria-labelledby="assignment-assessments-title"
      maxWidth="lg"
    >
      <DialogTitle id="assignment-assessments-title" classes={titleClasses}>
        <Box className={classes.title}>{title}</Box>
        <Box className={classes.close}>
          <IconButton onClick={close} size="large">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.contentWrapper}>
        <Box className={classes.content} ref={contentRef}>
          <Body context={context} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

function dialogStyles(theme) {
  return {
    paper: {
      width: '100%',
      padding: 0,
      height: 'calc(100% - 100px)'
    },
  }
}

function titleStyles(theme) {
  return {
    root: {
      display: 'flex',
      padding: '10px 10px 10px 24px',
      fontSize: '14pt',
      fontWeight: 'bold',
      borderBottom: 'solid 1px #f3f3f3',
      color: '#525b6c',
      background: '#fdfdfd'

    }
  }
}

function previewStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    title: {
      flexGrow: 1,
      ...verticalCentering
    },
    close: {
      ...verticalCentering,
      color: '#69738',
      padding: 0,
      "& svg": {
        fontSize: '14pt'
      }
    },
    button: {
      textDecoration: 'none',
      color: '#fff',
      display: 'flex',
      padding: '7px 15px 7px 12px',
      backgroundColor:'#2ca5ec',
      borderRadius: 3,
      '& >div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      '& .label': {
        fontSize: '13pt'
      },
      cursor: 'pointer',
      '&:hover': {
      },
      '& .icon': {
        marginTop: -1,
        marginRight: 4,
        fontSize: '8pt'
      },
    },
    contentWrapper: {
      padding:0,
      marginTop: 5,
    },
    content: {
      display: 'flex',
    },
    actions: {
      padding: 24
    }
  }
}
